<template>
  <div class="content-container">
    <div class="das-form-container" style="user-select: none">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-3">
            <div class="label">Thông tin khách sạn</div>
            <el-select
              v-model="hotelId"
              placeholder=""
              @change="onChangeHotel($event)"
            >
              <el-option label="Chọn" :value="null"></el-option>
              <el-option
                v-for="item in allHotelOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <!-- <div class="child-w-80">
              <select
                v-model="hotelId"
                placeholder="Chọn"
                @change="onChangeHotel($event)"
              >
                <option
                  v-for="option in allHotelOptions"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </div> -->
          </div>
          <!-- <div class="das-form-col col-3">
            <div class="label">Tòa nhà</div>
            <div class="child-w-80">
              <select
                v-model="buildingId"
                placeholder="Chọn"
                @change="onChangeBuilding"
              >
                <option
                  v-for="option in listBuildings"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div v-loading="loading" class="wrapper">
      <div class="container">
        <div
          v-for="item in data"
          :id="'id-' + item.id"
          :key="item.id"
          class="item"
        >
          <div class="room-level-name">{{ item.room_level_name }}</div>
          <div class="room-num">{{ item.room_num }}</div>
        </div>
      </div>
    </div>
    <div class="button-containers mt-10">
      <button :disabled="!isChange" class="btn primary small" @click="onSave">
        {{ $t('button.update') }}
      </button>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
// import { getListBuildingByHotelIdApi } from '@/api/Room/building.js'
import { getAllHotel } from '@/api/hotel.js'
export default {
  components: {},
  data() {
    return {
      loading: false,
      data: [],
      initData: [],
      isChange: false,
      // buildingId: null,
      hotelId: null,
      allHotelOptions: []
      // listBuildings: []
    }
  },
  async mounted() {
    const data = await getAllHotel()
    this.allHotelOptions = data.data
    // console.log('allHotelOptions ', this.allHotelOptions)
    // const data = await getListBuildingApi()
    // this.listBuildings = data.data
    // this.buildingId = this.listBuildings[0].id
    // await this.attachData(this.buildingId)
  },
  methods: {
    // async onChangeBuilding() {
    //   await this.attachData(this.buildingId)
    // },
    async onChangeHotel(e) {
      // await this.attachData(this.buildingId)
      this.loading = true
      // this.buildingId = null
      this.data = []
      this.initData = []
      // const param = {
      //   hotelId: this.hotelId
      // }
      // const data = await getListBuildingByHotelIdApi(param)
      // this.listBuildings = data.data
      await this.attachData(this.hotelId)
      this.loading = false
    },
    async attachData(id) {
      this.loading = true
      await this.$axios
        .get(`/config-service/v1/hotel/room/room-map/${id}`)
        .then(res => {
          this.data = res.data.map(item => {
            return {
              ...item,
              isDragging: false,
              clientX: false,
              clientY: false
            }
          })
          console.log('DATAAA', this.data)
          setTimeout(() => {
            for (let i = 0; i < this.data.length; i++) {
              const id = 'id-' + this.data[i].id
              const element = document.getElementById(`${id}`)
              element.style.background = this.data[i].building_color
              element.style.top = this.data[i].y + 'px'
              element.style.left = this.data[i].x + 'px'
              // mouse down
              element.addEventListener('mousedown', event => {
                console.log('Mouse down: ', i)
                element.style.zIndex = 10
                element.style.border = '2px solid #357456'
                this.data[i].isDragging = true
                this.data[i].clientX = event.clientX
                this.data[i].clientY = event.clientY
                this.isChange = true
              })
              // mouse move
              window.addEventListener('mousemove', event => {
                console.log('1111', this.data[i])
                if (this.data[i].isDragging) {
                  const x = Number(element.style.left.slice(0, -2))
                  const y = Number(element.style.top.slice(0, -2))
                  if (x < -5 || y < -5 || x > 1915 || y > 1945) {
                    document.querySelector('.wrapper').style.border =
                      '2px solid red'
                  } else {
                    document.querySelector('.wrapper').style.border =
                      '2px solid #DEDFE7'
                  }
                  console.log('Mouse mouse: ', event.clientX)
                  const a = event.clientX - this.data[i].clientX
                  const b = event.clientY - this.data[i].clientY
                  if (a % 1 === 0) {
                    element.style.left = this.data[i].x + a + 'px'
                  }
                  if (b % 1 === 0) {
                    element.style.top = this.data[i].y + b + 'px'
                  }
                  console.log('222:', x, y)
                }
              })
              // mouse up
              document.addEventListener('mouseup', () => {
                const dragStatus = this.data[i].isDragging
                if (dragStatus) {
                  element.style.zIndex = 1
                  element.style.border = 'none'
                  this.data[i].isDragging = false
                  let x = Number(element.style.left.slice(0, -2))
                  let y = Number(element.style.top.slice(0, -2))
                  // check border of drag
                  x < 0 ? (x = 0) : null
                  y < 0 ? (y = 0) : null
                  x > 1910 ? (x = 1910) : null
                  y > 1940 ? (y = 1940) : null
                  document.querySelector('.wrapper').style.border =
                    '2px solid #DEDFE7'
                  const z = x % 10
                  const t = y % 10
                  if (z < 5) {
                    this.data[i].x = x - z
                  } else {
                    this.data[i].x = x + (10 - z)
                  }
                  if (t < 5) {
                    this.data[i].y = y - t
                  } else {
                    this.data[i].y = y + (10 - t)
                  }
                  element.style.left = this.data[i].x + 'px'
                  element.style.top = this.data[i].y + 'px'
                  // console.log('element.style.left', element.style.left)
                  // console.log('element.style.top', element.style.top)
                }
              })
            }
            this.loading = false
          }, 300)
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    postData() {
      const data = this.data.map(item => {
        return {
          id: item.id,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height
        }
      })
      this.loading = true
      this.$axios
        .put('/config-service/v1/hotel/room/room-map', {
          room_list: data
        })
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Lưu thành công'
          })
          this.isChange = false
        })
        .catch(error => {
          console.log(error)
          this.$message({
            type: 'error',
            message: 'Lưu không thành công, thử lại sau'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.postData()
    },
    onReset() {
      Object.assign(this.data, this.initData)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  border: 2px solid #dedfe7;
  overflow: auto;
  .container {
    position: relative;
    width: 2000px;
    height: 2000px;
    background: linear-gradient(-90deg, rgba(0, 0, 0, 0.05) 1px, transparent 0)
        0 0/10px 10px,
      linear-gradient(rgba(0, 0, 0, 0.05) 1px, transparent 0) 0 0/10px 10px;
    overflow: hidden;
    .item {
      // background: green;
      padding: 5px;
      position: absolute;
      z-index: 1;
      top: 10px;
      left: 10px;
      height: 80px;
      width: 100px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      div {
        line-height: 16px;
        user-select: none;
        width: 100%;
        &.room-level-name {
          // background: red;
          min-height: 50px;
          max-height: 50px;
          overflow: hidden;
          font-weight: bold;
        }
        &.room-num {
          overflow: hidden;
          text-wrap: nowrap;
        }
        color: white;
        font-size: 12px;
      }
    }
  }
}
</style>
